import { FC, PropsWithChildren } from 'react';
import { ReactNode } from 'react';

export interface ContextProviderProps {
    children: ReactNode;
}

export type ComponentWithChildren = FC<PropsWithChildren<ContextProviderProps>>;

export function CombinedContextProvider(...components: ComponentWithChildren[]): ComponentWithChildren {
    return components.reduce(
        (AccumulatedComponents, CurrentComponent) =>
            ({ children }) =>
                (
                    <AccumulatedComponents>
                        <CurrentComponent>{children}</CurrentComponent>
                    </AccumulatedComponents>
                ),
        ({ children }) => <>{children}</>
    );
}
